import fx from "simple-fxtrade";

const oandaConnect = async () => {
  // Configure api key
  fx.configure({
    apiKey: process.env.REACT_APP_OANDA_API_KEY,
    live: false,
  });

  try {
    // Get accounts for authorized user
    const {
      accounts: [{ id }],
    } = await fx.accounts();
    // Set the id context for all future api calls
    fx.setAccount(id);
  } catch (error) {
    console.error("[OANDA] Failed to connect to OANDA:", error);
    throw error;
  }
};

// FIX: Use ES6 export syntaxs
export default oandaConnect;